import { Card, CardBody, Col } from "reactstrap";
import { ImagesSizes } from "../../../../Constant";
import { IMAGES, IMAGE_DATA } from "../../../../Data/UiKit/HelperClasses";
import { Image } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { dynamicImage } from "../../../../Service/DynamicImage";

const ImagesSizesCart = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={ImagesSizes} span={IMAGE_DATA} />
        <CardBody>
          <div className="gradient-border gap-3">
            <Image className="img-10 img-h-10" src={dynamicImage("blog/comment.jpg")} alt="img-size-10" />
            {IMAGES.map(({ className, src, alt }, index) => (
              <Image className={className} src={src} alt={alt} key={index} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ImagesSizesCart;
